import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import type { RouteComponentProps } from 'react-router';
import type { RouteTypes } from '~/app/routes/routes.types';
import { getSecuredRoutesForUserPermissions } from '~/app/routes/routes-utils';
import { getUserRoles } from '~/utils/roles-helper/roles-helper';
import { getUserPermissions } from '~/utils/permissions-helper/permissions-helper';
import SuspendedRoute from '~/components/views/SuspendedRoute/SuspendedRoute';

const getKey = (path: RouteTypes['path']): string => (Array.isArray(path) ? path[0] : path);

export const getRouteComponentsForUser = (): React.ReactNode => {
  const userPermissions = getUserRoles();
  const permissions = getUserPermissions();
  const permittedRoutes = getSecuredRoutesForUserPermissions(userPermissions, permissions);

  return permittedRoutes.redirectRoutes
    .map((route) => (
      <Route
        exact
        key={getKey(route.path)}
        path={route.path}
        render={(props: RouteComponentProps) => {
          return (
            <Redirect to={route.redirect(props.match.params, props.location.search)} push={false} />
          );
        }}
      />
    ))
    .concat(
      permittedRoutes.componentRoutes.map((route) => (
        <SuspendedRoute
          exact
          key={getKey(route.path)}
          path={route.path}
          render={(props) => <route.Component {...props} />}
        />
      ))
    );
};
